export var orderedStyles;

(function (orderedStyles) {
  orderedStyles["DECIMAL"] = "decimal";
  orderedStyles["LOWER_ALPHA"] = "lower-alpha";
  orderedStyles["UPPER_ALPHA"] = "upper-alpha";
})(orderedStyles || (orderedStyles = {}));

export var unorderedStyles;

(function (unorderedStyles) {
  unorderedStyles["CIRCLE"] = "circle";
  unorderedStyles["DISC"] = "disc";
  unorderedStyles["NONE"] = "none";
  unorderedStyles["SQUARE"] = "square";
})(unorderedStyles || (unorderedStyles = {}));